import TRAMETRIC_EXT_1 from "./TRAMETRIC_EXT_1";

export default {
  TRAMETRIC_EXT_1,
};
